"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonNotifications_de_de = void 0;
function commonNotifications_de_de() {
    return {
        "notifications.title": "Benachrichtigungen",
        "notifications.empty": "Hier werden aktuelle Benachrichtigungen angezeigt. Im Moment gibt es nichts neues.",
        "notifications.confirmation.title": "Bestätigung",
        "notifications.warning.title": "Warnung",
        "notifications.error.title": "Fehler",
        "notifications.error.message": "Es ist ein Fehler aufgetreten!",
        "notifications.success.title": "Erfolgreich",
        "notifications.added.title": "Erfolgreich hinzugefügt.",
        "notifications.deleted.title": "Erfolgreich gelöscht.",
        "notifications.edited.title": "Erfolgreich bearbeitet.",
        "notifications.markedasdone.title": "Erfolgreich als erledigt markiert.",
        "notifications.markedasopen.title": "Erfolgreich als offen markiert.",
        "notifications.favorites.added": "Zu Favoriten hinzugefügt.",
        "notifications.favorites.removed": "Von Favoriten entfernt."
    };
}
exports.commonNotifications_de_de = commonNotifications_de_de;
